import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import { Prompt } from 'react-router';
import { useParams } from 'react-router-dom';
import EditFAQStatusSwitcher from './components/EditFAQStatusSwitcher/EditFAQStatusSwitcher';
import EditFAQContentBlock from './containers/EditFAQContentBlock/EditFAQContentBlock';
import EditFAQDetailsBlock from './containers/EditFAQDetailsBlock/EditFAQDetailsBlock';
import editFAQStore from './store/editFAQStore';
import { SCREENS } from 'src/constants/screens';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';

const EditFAQScreen: React.FC = observer((): JSX.Element => {
  const { id: faqId } = useParams<{ id?: string }>();
  const headerTitle = useMemo((): string => (faqId ? 'update_faq_page' : 'create_faq_page'), [faqId]);

  useEffect(() => {
    editFAQStore.init(faqId);
  }, []);

  return (
    <div className="d-flex flex-column flex-1">
      <Headers>
        <HeaderBack title={headerTitle} path={SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ()} />
      </Headers>

      <ScrollableBlock showScrollbar scrollbarSize="normal" className="flex-1 mt-6" scrollClassName="d-flex flex-column gap-30">
        <EditFAQStatusSwitcher />

        <EditFAQContentBlock />
        <EditFAQDetailsBlock />

        <SettingControlsBlock
          redirectPath={SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ()}
          setValidation={editFAQStore.setValidation}
          onSubmit={editFAQStore.onSubmit}
        />
      </ScrollableBlock>

      <LoadingOverlay visible={editFAQStore.isLoading} />
      <Prompt when={editFAQStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default EditFAQScreen;
